import { render, staticRenderFns } from "./useRecordDialog.vue?vue&type=template&id=cf9bc8fa&scoped=true&"
import script from "./useRecordDialog.vue?vue&type=script&lang=js&"
export * from "./useRecordDialog.vue?vue&type=script&lang=js&"
import style0 from "./useRecordDialog.vue?vue&type=style&index=0&id=cf9bc8fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9bc8fa",
  null
  
)

export default component.exports